import React, {Component} from 'react'
import {RouteComponentProps, withRouter} from 'react-router-dom'
import {UserData} from '../apis/user.api'
import routes from '../routes/routes'
import assetUtil from '../utils/asset.util'
import Clock from './Clock'
import Logo from './Logo'
import Menu from './Menu'
import MenuFolder from './MenuFolder'
import SidebarClose from './SidebarClose'
import TrialAlert from './TrialAlert'
import User from './User'
import storageService from '../services/storage.service'
import Icon from '../components/Icon'
import {i18n} from '../i18n/i18n'
import SandboxBadge from './SandboxBadge'

interface SidebarProps extends RouteComponentProps {
    visible: boolean
    user: UserData | null
    permittedModules: string[]
    onClose: () => void
    onRoute: () => void
}

interface SidebarState {
    fold: boolean
}

class Sidebar extends Component<SidebarProps, SidebarState> {
    constructor(props: SidebarProps) {
        super(props)
        this.state = {
            fold: false,
        }
        this.handleLogoClick = this.handleLogoClick.bind(this)
        this.handleFoldChange = this.handleFoldChange.bind(this)
        this.handleLogOut = this.handleLogOut.bind(this)
    }

    get className() {
        const base = 'bg-primary p-4 h-screen overflow-auto absolute w-full sm:relative sm:block z-40'
        const width = this.state.fold ? 'sm:w-60' : 'sm:w-96'
        const display = this.props.visible ? 'block' : 'hidden'
        return `${base} ${width} ${display}`
    }

    get userClass() {
        return this.state.fold ? 'hidden' : 'block'
    }

    get clockClass() {
        return this.userClass
    }

    get logOutClass() {
        const base =
            'cursor-pointer absolute bottom-4 ' +
            'flex items-center justify-center text-white text-xs bg-[#dc3813] ' +
            'py-2 px-4  transition-colors gap-1 '
        return `${base}`
    }

    get logo() {
        const {user} = this.props
        if (
            !user ||
            !user.site ||
            !user.site.subscriber ||
            !user.site.subscriber.logo
        ) return
        return assetUtil.storageUrl(user.site.subscriber.logo)
    }

    get site() {
        const {user} = this.props
        if (!user || !user.site) return null
        return user.site
    }

    get subscriber() {
        const {user} = this.props
        if (!user || !user.site) return null
        return user.site.subscriber
    }

    get subscriberName() {
        if (!this.subscriber) return null
        return this.subscriber.name
    }

    get siteName() {
        if (!this.site) return null
        return this.site.name
    }

    get username() {
        const {user} = this.props
        if (!user) return ''
        return user.username
    }

    handleLogoClick() {
        this.props.history.push(routes.dashboard)
        this.props.onClose()
    }

    handleFoldChange() {
        this.setState(state => {
            const fold = !state.fold
            return {fold}
        })
    }

    handleLogOut() {
        this.props.history.push(routes.logout)
    }


    render() {
        return (
            <div className={this.className}>
                <div className="flex justify-between">
                    <Logo type="regular" onClick={this.handleLogoClick}/>
                    <MenuFolder
                        fold={this.state.fold}
                        onChange={this.handleFoldChange}/>
                    <SidebarClose onClick={this.props.onClose}/>
                </div>
                <SandboxBadge/>
                <div className="flex justify-between items-center mt-4">
                    <div className={this.clockClass}>
                        <p className="text-white text-xs">
              <span className='font-medium text-sm'>
                {this.subscriberName}
              </span>&nbsp;
                            {this.siteName}
                        </p>
                        <Clock/>
                    </div>
                    <div className={this.userClass}>
                        <User
                            logo={this.logo}
                            username={this.username}/>
                    </div>
                </div>
                <TrialAlert site={this.site}/>
                <div className="mt-2">
                    <Menu
                        fold={this.state.fold}
                        permittedModules={this.props.permittedModules}
                        onRoute={this.props.onRoute}/>
                </div>
                <button
                    className={this.logOutClass}
                    onClick={this.handleLogOut}
                >
                    <Icon name={'logout-box-r'} size={'medium'} color={'white'}/>
                    {i18n('Logout')}
                </button>

            </div>
        )
    }
}

export default withRouter(Sidebar)
